var map = {
	"./user-review-1.jpeg": 38099,
	"./user-review-2.jpeg": 22182,
	"./user-review-3.jpeg": 52397,
	"./user-review-4.jpeg": 15256,
	"./user-review-5.jpeg": 31772
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 57891;